import { Box, Button, Grid, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { loginUser } from './LoginRequest'
import { blue } from '@mui/material/colors'
import BG from '../../assets/img/bg.jpg';
export const LoginPage = () => {
    const user = localStorage.getItem('user')
    const [loginInfo,setLoginInfo] = useState({
        code:'',
        username:''
    })
    const handleChange = (e,name) => {
        setLoginInfo({
            ...loginInfo,
            [name]:e.target.value
        })
    }
    useEffect(()=>{
        if(user){
            window.location.href = '/dashboard'
        }
    },[])
    const handleLogin  =  async (e) =>{
        e.preventDefault();
        const toastId = toast.loading('Verifying User');
        // console.log(loginInfo)
        const res  = await loginUser(loginInfo);
        if(res.data.status === 200){
            //set user info
            localStorage.setItem('user',JSON.stringify(res.data.data));
            toast.success(res.data.message, {
                id: toastId,
            });
            window.location.href = '/dashboard';
        }else{
            // toast.dismiss(toastId);
            toast.error(res.data.message, {
                id: toastId,
            });

        }
        
        
    }
    
    return (
        <>
            {
                user
                ?
                null
                :
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',p:5,height:'100dvh'}} className='login-bg'>
                    <form onSubmit={handleLogin}>
                    <Box sx={{display:'flex',flexDirection:'column',gap:1,p:3}} component={Paper}>
                        <Typography variant='h4' sx={{textAlign:"center",color:blue[800]}} className='good-timing'>Tabulation System</Typography>
                        <TextField label = 'Username' value={loginInfo.username} onChange={(e)=>handleChange(e,'username')} required/>
                        <TextField label = 'Code' value={loginInfo.code} onChange={(e)=>handleChange(e,'code')} required/>
                        <Button variant='contained' type='submit'>Login</Button>
                    </Box>
                    </form>

                </Box>
            }
        </>
        
    )
}